import { render, staticRenderFns } from "./CommunityParticipants.vue?vue&type=template&id=20a6e4a4&scoped=true&"
import script from "./CommunityParticipants.vue?vue&type=script&lang=js&"
export * from "./CommunityParticipants.vue?vue&type=script&lang=js&"
import style0 from "./CommunityParticipants.vue?vue&type=style&index=0&id=20a6e4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a6e4a4",
  null
  
)

export default component.exports